import { MessageDesignTokens } from "@primeuix/themes/types/message"

const index: MessageDesignTokens = {
  text: {
    fontSize: '0.8rem',
    fontWeight: 'normal'
  },
  content: {
    padding: '0.75rem 1rem'
  },
  colorScheme: {
    light: {
      success: {
        background: '{success.background.color}',
        color: '{success.color}',
        borderColor: '{success.border.color}'
      },
      info: {
        background: '{info.background.color}',
        color: '{info.color}',
        borderColor: '{info.border.color}'
      },
      warn: {
        background: '{warning.background.color}',
        color: '{warning.color}',
        borderColor: '{warning.border.color}'
      },
      error: {
        background: '{danger.background.color}',
        color: '{danger.color}',
        borderColor: '{danger.border.color}'
      }
    }
  }
}

export { index as default }
